module.exports = __webpack_public_path__ + "img/EY_Logo_Beam_RGB.caa383fc.jpg";